import { MenuGroup } from "./MenuGroup";
import { RouteEnum } from "../enums/RouteEnum";
import { JSX } from "react";

interface Props {
    location: string;
    setLocation: (location: string) => void;
}

export const EmployeeMenu = (props: Props): JSX.Element => {
    return (
        <>
            <MenuGroup
                label={"Algemeen"}
                menuItems={[
                    {
                        label: "Dashboard",
                        icon: "BarChart",
                        link: RouteEnum.DASHBOARD,
                    },
                    {
                        label: "Meldingen",
                        icon: "Notifications",
                        link: RouteEnum.NOTIFICATIONS,
                    },
                ]}
                location={props.location}
                setLocation={props.setLocation}
            />

            <MenuGroup
                label={"Opleidingen"}
                menuItems={[
                    {
                        label: "Kwalificaties",
                        icon: "School",
                        link: RouteEnum.QUALIFICATIONS,
                    },
                    {
                        label: "Verloopt binnenkort",
                        icon: "Clock",
                        link: RouteEnum.CERTIFICATE_EXPIRY,
                    },
                    {
                        label: "Ingepland",
                        icon: "Agenda",
                        link: RouteEnum.SCHEDULED_QUALIFICATIONS,
                    },
                    {
                        label: "Certificaten",
                        icon: "DeveloperGuide",
                        link: RouteEnum.ACHIEVEMENTS,
                    },
                ]}
                location={props.location}
                setLocation={props.setLocation}
            />

            <MenuGroup
                label={"Persoonlijk"}
                menuItems={[
                    {
                        label: "Gegevens beheren",
                        icon: "Person",
                        link: RouteEnum.DATA_MANAGEMENT,
                    },
                ]}
                location={props.location}
                setLocation={props.setLocation}
            />
        </>
    );
};
